import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges, OnChanges } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select'
import { I18NextPipe } from 'angular-i18next';


@Component({
    selector: 'app-widget-user-group-select',
    templateUrl: './widget-user-group-select.component.html',
    styleUrls: ['./widget-user-group-select.component.scss'],
    standalone: false
})
export class WidgetUserGroupSelectComponent implements OnInit, OnChanges {

  @Input() items: Array<any>;
  @Input() bindLabel: string;
  @Input() bindValue: string;
  @Input() placeholder: string = "Select";
  @Input() translateItems: boolean = false;
  @Input() model: any;
  @Output() modelChange = new EventEmitter<any>();
  @Input() title: string;
  @Input() exclude: boolean;
  @Output() excludeChange = new EventEmitter<boolean>();
  isOpen: boolean;
  isInitialized = false;
  restrictedItems: any;
  isFiltered: boolean = false;
  filteredItems: Array<any>;
  selectedItems: Array<any> = [];

  constructor(private i18nextPipe: I18NextPipe) { }
  get isAllItemsSelected(): boolean {
    return this.items?.length + this.restrictedItems?.length == this.model?.length;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.items && this.model) {
      this.model = this.model.map(m => m.toString());
      if (!this.isInitialized) {
        let userGroupsIdsToAdd = [];
        for (let i = 0; i < this.model.length; i++) {
          let str = this.model[i];
          let index = str.indexOf("_");
          if (index > -1) {
            str = str.substring(0, index);
          }
          let filteredUserGroupsById = this.items.filter(x => x.usergroupId.toString().includes(str));
          for (let j = 0; j < filteredUserGroupsById.length; j++) {
            let currentUserGroupId = filteredUserGroupsById[j].usergroupId;
            this.selectedItems.push(str);
            if (this.model.indexOf(currentUserGroupId) < 0) {
              userGroupsIdsToAdd.push(currentUserGroupId);
            }
          }
        }
        this.model.push(...userGroupsIdsToAdd);
      }
      // let itemIds = this.items.map((i) => i[this.bindValue]);
      // this.restrictedItems = this.model.filter((v) => { return !itemIds.includes(v); });
      // this.isInitialized = true;
    }
  }

  ngOnInit(): void { }

  get isAllFilteredItemsSelected(): boolean {
    return this.isFiltered && this.filteredItems?.every(i => this.model?.indexOf(i[this.bindValue]) > -1);
  }

  onSearch($event) {
    this.isFiltered = $event.term.length > 0;
    this.filteredItems = $event.items;
  }

  onClick($event) {
    if (this.items && this.model) {
      let isSelected = $event.target.ariaSelected;
      if (isSelected && this.isOpen) {
        let ugName = $event.target.innerText;
        let ug = this.items.find(i => i.usergroupName === ugName);
        let ugId = ug.usergroupId;
        let dashIndex = ugId.indexOf("_");
        if (dashIndex > -1) {
          ugId = ugId.substring(0, dashIndex);
        }
        if (isSelected.toString() === "true") {
          for (let i = 0; i < this.items.length; i++) {
            let itemId = this.items[i].usergroupId;
            if (itemId.includes(ugId)) {
              if (this.model.indexOf(itemId) < 0) {
                this.model.push(itemId);
              }
            }
          }
        } else {
          this.model = this.model.filter(m => !m.includes(ugId));
        }
      }

      let itemIds = this.items.map((i) => i[this.bindValue]);
      this.restrictedItems = this.model.filter((v) => { return !itemIds.includes(v); });
      this.isInitialized = true;
      this.modelChange.emit(this.model);
    }

  }

  selectAll(ngSelectControl: NgSelectComponent) {
    let model = [...this.model ?? []];
    if (this.isFiltered && !this.isAllFilteredItemsSelected) {
      this.filteredItems?.forEach(element => {
        if (model.indexOf(element[this.bindValue]) == -1) {
          model.push(element[this.bindValue]);
        }
      });
    } else if (this.isFiltered && this.isAllFilteredItemsSelected) {
      this.filteredItems?.forEach(element => {
        let index = model.indexOf(element[this.bindValue]);
        if (index > -1) {
          model.splice(index, 1);
        }
      });
    } else if (!this.isAllItemsSelected) {
      model = this.items.map(p => p[this.bindValue]);
    }
    else {
      model = [];
      this.restrictedItems?.forEach(element => {
        model.push(element);
      });
    }
    this.model = model;
    this.modelChange.emit(this.model);
  }

  itemText(id: number | string) {
    let item = this.items?.find((i) => i[this.bindValue] == id)
    return item ? item[this.bindLabel] : '';
  }

  itemExists(id: number | string) {
    return this.items?.find((i) => i[this.bindValue] == id) != undefined;
  }

  clearItem(ngSelectControl: NgSelectComponent, id: number) {
    ngSelectControl.clearItem(this.items?.find((i) => i[this.bindValue] == id));
  }

  customSearchFn = (term: string, item: any) => {
    let name = item[this.bindLabel];
    if (this.translateItems) {
      name = this.i18nextPipe.transform('dashboard:' + name)
    }
    return name.toLocaleLowerCase().indexOf(term.toLocaleLowerCase()) > -1;
  }

  onExcludeclick() {
    this.exclude = !this.exclude;
    this.excludeChange.emit(this.exclude);
  }

  selectOpen() {
    this.isOpen = true;
    this.SetScroolToBottom();
  }

  SetScroolToBottom() {
    let container = document.querySelector<HTMLElement>('.mat-horizontal-content-container');
    if (container) {
      setTimeout(() => {

        try {
          container.scrollTop = container.scrollHeight;
        } catch { }
      }, 0);
    }

  }
}
